<template>
    <component :is="componentToRender"
        v-bind="$props"
    />
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

import predictorDetailsFootball from '@webapp/modules/fan-engagement/components/predictor/football/details.vue';
import predictorDetailsAmericanFootball from '@webapp/modules/fan-engagement/components/predictor/american-football/details.vue';

import {
    SPORT_IDS,
} from '@shared/modules/fan-engagement/constants/sportEventSports';

export default {
    name: 'predictor-details-landing',
    components: {
        predictorDetailsFootball,
        predictorDetailsAmericanFootball,
    },
    computed: {
        ...mapGetters('predictorTeams', [
            'getCurrentTeam',
            'getTeamPartnerIdById',
        ]),

        componentToRender() {
            if (
                [SPORT_IDS.AMERICAN_FOOTBALL, SPORT_IDS.RUGBY_UNION]
                    .includes(this.getCurrentTeam?.sport?.id)
            ) {
                return predictorDetailsAmericanFootball;
            }

            return predictorDetailsFootball;
        },

        partnerId() {
            return this.getTeamPartnerIdById(this.$route.params.teamId);
        },
    },
    watch: {
        getLatestValidationError: 'handleError',
        getSubmittedPredictions: 'markVoteAsSubmitted',
        sportEvent: {
            deep: true,
            handler(sportEvent) {
                if (!sportEvent) {
                    this.$router.push('/404');
                }
            },
        },
    },
    async created() {
        const {
            sportEventId = null, teamId = null,
        } = this.$route.params;

        await this.fetchTeamById(teamId);

        if (!sportEventId || !teamId || !this.partnerId || !this.getCurrentTeam?.sport?.id) {
            this.$router.push('/404');
        }
    },
    methods: {
        ...mapActions('predictorTeams', ['fetchTeamById']),
    },
};
</script>